import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Textbox } from './../../models/editors/textbox.model';

import { EstateAgent } from './../../models/real-estates/real-estates.model';

import { ApiService } from './../../shared/services/api.service';
import { FormControlService } from './../../shared/services/form-control.service';
import { AlertService } from './../../shared/services/alert.service';
import { Contained } from './../../models/editors/contained.model';
import { FormDetailBase } from './../../shared/components/base/form-detail/form-detail.base.component';
import { Validators } from '@angular/forms';
import { EntityService } from './../../shared/services/entity.service';

@Component({
  selector: 'swb-estate-agent-detail',
  templateUrl: './estate-agent-detail.component.html',
  providers: [FormControlService]
})
export class EstateAgentDetailComponent extends FormDetailBase<EstateAgent> implements OnInit {
  public url = 'estate-agents';
  protected _redirect = './real-estate';

  public entity = new EstateAgent({});

  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: 'title',
        label: 'Jméno',
        validators: [Validators.required]
      }),
      new Textbox({
        key: 'phone',
        label: 'Telefon',
        type: 'tel'
      }),
      new Textbox({
        key: 'email',
        label: 'E-mail',
        validators: [Validators.required]
      }),
      new Contained({
        key: 'file_id',
        entity: this.entity.file,
        label: 'Obrázek'
      })
    ];
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute,
    private _entityService: EntityService
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {

    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }

    if (this._route.outlet === 'modal-form') {
      this.isModal = true;
      this._redirect = undefined;
      this._saveCallback = this._saveCallback = (response) => {
        const item = { ...response }.data;
        this._entityService.setChosenEntities([item], 'estate-agents');
        this._closeCallback();
      };
      this._closeCallback = () => {
        this._router.navigate([{ outlets: { 'modal-form': null } }], {
          relativeTo: this._route.parent
        });
      };
      this._id = undefined; // TODO: better?
      window.scrollTo(0, 0);
    }

    this._getEntity();

  }

}
